import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import QuoteVersionList from './QuoteVersionList';

/**
 * All sent quote versions of a work order with their acceptance state. Opened from
 * the header indicator chip and from the Toiminnot menu, in any work order state.
 */
function QuoteHistoryDialog({ open, handleClose, maintenance }) {
  const { t } = useTranslation();
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open || !maintenance?.id) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    axios
      .get(`/api/maintenances/${maintenance.id}/quotes/`)
      .then((response) => {
        if (!cancelled) setQuotes(Array.isArray(response.data) ? response.data : []);
      })
      .catch(() => {
        if (!cancelled) setError(t('quoteSnapshot.errorLoading'));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, maintenance?.id, t]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth data-testid="quote-history-dialog">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <RequestQuoteIcon color="primary" />
        <Box>
          {t('quoteSnapshot.sentQuotes')}
          {maintenance?.vehicle?.registration_number && (
            <Typography variant="body2" color="text.secondary">
              {maintenance.vehicle.registration_number}
              {maintenance.work_number ? ` · ${maintenance.work_number}` : ''}
            </Typography>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <QuoteVersionList quotes={quotes} onError={setError} data-testid="quote-history-list" />
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose}>{t('Close')}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default QuoteHistoryDialog;
